"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingHintTextWrap = exports.SettingHintIconWrap = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styles_1 = require("@material-ui/styles");
var Icon_1 = tslib_1.__importDefault(require("@material-ui/core/Icon"));
var Typography_1 = tslib_1.__importDefault(require("@material-ui/core/Typography"));
var useStyles = styles_1.makeStyles(function (theme) { return ({
    HintIcon: {
        display: "flex",
        alignItems: "center",
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 8,
        paddingBottom: 8,
        height: 24,
    },
    HintIcon_wrap: {
        display: "flex",
        alignItems: "center",
        height: 24,
        width: 24,
        marginRight: 8,
    },
    HintIconItem: {
        color: theme.app.Setting.color6,
        "&:hover": {
            color: theme.app.Setting.color7,
        },
    },
    HintText: {
        display: "flex",
        alignItems: "center",
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 8,
        paddingBottom: 8,
    },
    HintText_wrap: {
        display: "flex",
        alignItems: "center",
        fontSize: 12,
        fontWeight: 400,
        marginRight: 8,
        color: theme.app.Setting.color5,
    },
}); });
function SettingHintIconWrap(props) {
    var data = props.data;
    var classes = useStyles();
    return (react_1.default.createElement("div", { className: classes.HintIcon }, data.map(function (item, index) { return (react_1.default.createElement("div", { key: index, className: classes.HintIcon_wrap },
        react_1.default.createElement("a", { href: item.url, target: "_blank" },
            react_1.default.createElement(Typography_1.default, { color: "textPrimary", className: classes.HintIconItem },
                react_1.default.createElement(Icon_1.default, { style: { fontSize: 24 } }, item.icon))))); })));
}
exports.SettingHintIconWrap = SettingHintIconWrap;
function SettingHintTextWrap(props) {
    var text = props.text;
    var classes = useStyles();
    return (react_1.default.createElement("div", { className: classes.HintText },
        react_1.default.createElement("div", { className: classes.HintText_wrap }, text)));
}
exports.SettingHintTextWrap = SettingHintTextWrap;
//# sourceMappingURL=indexWrap.js.map